import { useContext, useMemo } from 'react';
import { UserContext } from '../context/user';
import { Rating } from 'react-simple-star-rating';
import { T } from "react-translator-component";
import { i18nValue } from '../functions';
import {
  getReviewQuestionOption,
  normalizeReviewQuestionBlocks,
  parseReviewAnswers,
  REVIEW_QUESTION_TYPES,
} from './Reviews/reviewQuestionBlocks';



const Rated = ({ hasRated, fullBleed }) => {

  const { language } = useContext(UserContext);
  const extraReviews = useMemo(() => parseReviewAnswers(hasRated?.extraReviews), [hasRated?.extraReviews]);
  const questions = useMemo(
    () => normalizeReviewQuestionBlocks(hasRated?.ReviewSetting?.questions),
    [hasRated?.ReviewSetting?.questions]
  );
  const questionsById = useMemo(
    () =>
      questions.reduce((acc, question) => {
        acc[question.id] = question;
        return acc;
      }, {}),
    [questions]
  );

  let sumReviews = hasRated?.review;
  const numericExtraReviews = Object.entries(extraReviews).filter(([questionId, value]) => {
    const question = questionsById[questionId];
    return typeof value === 'number' &&
      question?.type !== REVIEW_QUESTION_TYPES.SINGLE_CHOICE_QUESTION &&
      question?.type !== REVIEW_QUESTION_TYPES.RANKING_QUESTION;
  });
  const extraReviewSum = numericExtraReviews.reduce((acc, [, value]) => acc + value, 0);
  sumReviews += extraReviewSum;

  const totalReviews = 1 + numericExtraReviews.length;
  const average = sumReviews / totalReviews;

  return (
    <>
      <div className="rate-container mt-5 p-4 w-100 rounded" style={{ backgroundColor: '#FFF' }}>
        <h6>
          {T('review.average')}
        </h6>
        <Rating initialValue={Math.round(average)} readonly />
      </div>

      <div className={`mt-3 ${fullBleed ? "w-100" : "w-75 mx-auto"}`}>

        <div className="d-flex border-bottom justify-content-between mx-10" >
          <span className='mt-2 p-1'>{T("review.general")}</span>
          <div className="d-flex align-items-center">
            <Rating
              initialValue={hasRated?.review}
              size={18}
              readonly
            />
          </div>
        </div>
        {Object.entries(extraReviews) && Object.entries(extraReviews).length > 0 && Object.entries(extraReviews).map(([id, answer]) => {
          const question = questionsById[id];
          const questionLabel = i18nValue(question || {}, "title", language, null, question?.title || id);

          if (
            question?.type === REVIEW_QUESTION_TYPES.SINGLE_CHOICE_QUESTION ||
            question?.type === REVIEW_QUESTION_TYPES.RANKING_QUESTION
          ) {
            const selectedOption = getReviewQuestionOption(question, answer);
            return (
              <div key={id} className="d-flex border-bottom w-100 justify-content-between mx-10">
                <span className='mt-2 p-1'>{questionLabel}</span>
                <div className="d-flex align-items-center">
                  <span className="badge badge-light-primary">
                    {i18nValue(selectedOption || {}, "label", language, null, selectedOption?.label || "-")}
                  </span>
                </div>
              </div>
            );
          }

          return (
            <div key={id} className="d-flex border-bottom w-100 justify-content-between mx-10" >
              <span className='mt-2 p-1'>{questionLabel}</span>
              <div className="d-flex align-items-center">
                <Rating
                  initialValue={answer}
                  size={18}
                  readonly
                />
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: 15, paddingTop: 15, borderTop: "1px solid #EEE" }}>
        <p>{T("review.already-rated")}</p>
      </div>

    </>
  )
}

export default Rated